import { render, staticRenderFns } from "./InvestmentInstrumentPieChart.vue?vue&type=template&id=861b5cb0&scoped=true"
import script from "./InvestmentInstrumentPieChart.vue?vue&type=script&lang=ts"
export * from "./InvestmentInstrumentPieChart.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentInstrumentPieChart.vue?vue&type=style&index=0&id=861b5cb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861b5cb0",
  null
  
)

export default component.exports